import { cloneDeep } from "lodash";
import { initialState } from "../initialState";
import { magazineActions as actions } from "../actions";
import { createReducer, methodSwitcher } from "./utilities";

const { magazine } = initialState;

const clearCurrent = (state) => ({ ...state, current: {} });

const setMagazineList = (state, { data }) => {
  const newState = cloneDeep(state);
  newState.list = data;
  return newState;
};

const setCurrentMagazine = (state, { data }) => {
  const newState = cloneDeep(state);
  newState.current = data;
  return newState;
};

const actionMagazine = (state, { data, id, method }) => {
  const newState = cloneDeep(state);
  methodSwitcher(newState, data, id, method);
  return newState;
};

export const magazineReducer = createReducer(magazine, {
  [actions.CLEAR_CURRENT]: clearCurrent,
  [actions.LIST]: setMagazineList,
  [actions.CURRENT]: setCurrentMagazine,
  [actions.CUD]: actionMagazine,
});
